import stripHtml from '@/client/utils/seo/stripHtml';

const getImageObjectSchema = (listings, locale) => {
  type listing = {
    title: string;
    itemId: string;
    description: string;
    sellerInformation: TSellerInformation;
    pictures?: {
      extraExtraLargeUrl: string;
    }[];
  };
  const creditTextMap = {
    'nl-NL': 'Marktplaats',
    'nl-BE': '2dehands',
    'fr-BE': '2ememain',
  };
  const creditText = creditTextMap[locale] || '';
  const MAX_DESCRIPTION_LENGTH = 190;

  const filteredListings = listings?.filter((listing: listing) => listing.pictures && listing.pictures.length > 0);
  if (!filteredListings.length) return;

  return filteredListings?.map((listing: listing) => {
    const { title, description, sellerInformation, pictures } = listing;

    return {
      '@context': 'https://schema.org',
      '@type': 'ImageObject',
      creditText: creditText,
      name: title,
      description: (() => {
        const cleaned = stripHtml(description);
        const truncated =
          cleaned.length > MAX_DESCRIPTION_LENGTH ? `${cleaned.substring(0, MAX_DESCRIPTION_LENGTH)}...` : cleaned;
        // substring counts each surrogate as 1 JS char, so it can split a valid emoji pair
        // at the boundary and leave a lone high surrogate — strip it after truncation.
        return truncated.replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])/g, '');
      })(),
      contentUrl: pictures?.[0].extraExtraLargeUrl,
      creator: {
        '@type': 'Person',
        name: sellerInformation?.sellerName,
      },
      representativeOfPage: false,
    };
  });
};

export default getImageObjectSchema;
